export default {
   AUTOPAY_CONFIGURATION_BEGIN: 'AUTOPAY_CONFIGURATION_BEGIN',
   AUTOPAY_CONFIGURATION_SUCCESS: 'AUTOPAY_CONFIGURATION_SUCCESS',
   AUTOPAY_CONFIGURATION_SETUP:'AUTOPAY_CONFIGURATION_SETUP',
   AUTOPAY_CONFIGURATION_ERROR: 'AUTOPAY_CONFIGURATION_ERROR',
   AUTOPAY_SETUP_ON_BEGIN:'AUTOPAY_SETUP_ON_BEGIN',
   AUTOPAY_SETUP_ON_SUCCESS:'AUTOPAY_SETUP_ON_SUCCESS',
   AUTOPAY_SETUP_ON_ERROR:'AUTOPAY_SETUP_ON_ERROR',
   AUTOPAY_SETUP_OFF:'AUTOPAY_SETUP_OFF',
};